module.exports = __webpack_public_path__ + "static/media/OURLOGO$.b345a3f0.png";